<template>
    <v-app>    
        <v-main>
            <v-container class="fill-height container-background" fluid></v-container>
            <v-container 
                class="fill-height justify-center" 
                fluid

            >
                <v-row 
                    justify="center" 
                    style="z-index:10"
                    class="my-auto"
                >
                    <v-col>
                        <v-card 
                            class="elevation-12 pa-4 mx-auto"
                            max-width="400"
                        >
                            <v-row justify="center">
                                <v-img
                                    src="../../assets/logo.png"
                                    max-width="120"
                                    contain
                                    class="d-flex"
                                ></v-img>                                            
                            </v-row>

                            <v-row no-gutters>
                                    <v-col cols="12">

                                        <div class="pa-4">
                                            <v-alert                                                    
                                                type="error"
                                                outlined                                                    
                                                v-if="getloginErrors"
                                                class="red--text"
                                            >
                                                <div>{{ getloginErrors }}</div>
                                            </v-alert>    
                                        </div>
                                    
                                    
                                        <div class="primary--text text-center font-weight-light">Welcome to </div>
                                        <div class="primary--text text-h4 text-sm-h5 text-center">{{ schoolName }}</div>
                                        <div class="primary--text text-center text-h4 mt-3 mb-6 font-weight-black"> Student E-Reports</div>
                                    
                                        <v-form 
                                            class="pa-5"
                                            @submit.prevent
                                        >
                                            <!-- <v-text-field
                                                label="Student ID"
                                                placeholder="Enter student ID"
                                                name="id"                                                
                                                type="text"
                                                color="primary"
                                                v-model="formData.student_id"
                                                clearable
                                                autofocus
                                            >
                                                <v-icon
                                                    slot="prepend"
                                                    color="primary"
                                                >
                                                    mdi-account
                                                </v-icon>
                                            </v-text-field>     -->
                                            
                                            <v-text-field
                                                    label="Birth Certificate Pin"
                                                    placeholder=""
                                                    persistent-hint
                                                    v-model="formData.birth_certificate_pin"
                                                    clearable
                                                    autofocus
                                                >
                                                    <v-icon
                                                        slot="prepend"
                                                        color="primary"
                                                    >
                                                        mdi-key
                                                    </v-icon>
                                                </v-text-field>
                                
                                            <div class="text-right mt-4  mb-4">                                                
                                                    <v-btn block color="primary" @click="submit" dark>LOGIN</v-btn>
                                                </div>
                                        </v-form>
                                </v-col>
                        
                            </v-row>                               
                                
                           
                        </v-card>
                    </v-col>
                </v-row>
                <v-overlay
                    :value="getOverlay"
                    opacity="0.8"
                    z-index="10"                    
                >
                    
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>                   
                </v-overlay>
            </v-container>            
        </v-main>
        
    </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    name: 'Login',
    components: {
    },
    data(){
        return {
            formData: {
                student_id: '',
                birth_certificate_pin: '',
            },
        }
    },         
    props: {
        source: String,
    },
    watch: {
        //             
    },
    computed: {
        ...mapGetters({
            getOverlay: 'auth/getOverlay',
            schoolName: 'form/getSchoolName',            
            getloginErrors: 'auth/getLoginErrors',
            getAuthenticated: 'auth/getAuthenticated',
            getResetPassword: 'auth/getResetPassword',
            validStudentID: 'auth/getStudentIDValidation',            
        }),       
        
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn',
            changePassword: 'auth/changePassword',
            changeResetPassword: 'auth/changeResetPassword',
            user: 'auth/user',
        }),
        ...mapMutations({
            openDialog: 'auth/setDialog',
            setNewPassword: 'auth/setNewPassword',
            setUserId: 'auth/setUserId',
            setOverlay: 'auth/setOverlay',
        }),
       
       
        async submit () {
            await this.signIn(this.formData);
            if(this.getAuthenticated){
                this.$router.replace('/term-report');
                this.setOverlay(false);
            }
            else{
                this.loginErrors = this.getLoginErrors 
            }                                               
        },
        
        
    }
}
</script>

<style scoped>
    .container-background{
        background-image: url('../../assets/background.jpg');
        background-position: center center;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        filter: brightness(40%);
        position: absolute;
    }    

</style>